import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'application/store';

import { ApplicationState } from './types';

export const selectApplicationState = (state: RootState): ApplicationState => state.application;

export const selectAppInitialized = createSelector(
  [selectApplicationState],
  (application) => application.appInitialized
);

export const selectAppBanned = createSelector([selectApplicationState], (application) => application.appBanned);

export const selectCaptchaToken = createSelector([selectApplicationState], (application) => application.captchaToken);

export const selectAuthToken = createSelector([selectApplicationState], (application) => application.authToken);

export const selectAppStatus = createSelector([selectApplicationState], (application) => application.appStatus);

export const selectIsAppLoading = createSelector(
  [selectApplicationState],
  (application) => application.appStatus === 'initializing'
);
